import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, styled } from "@material-ui/core";

import TimestampBox from "./TimestampBox";
import { ReactComponent as FlagIcon } from "../../../assets/images/ui/flag.svg"; 
import { ReactComponent as CheckIcon } from "../../../assets/images/ui/check.svg"; 
import UnderlineBoxWithSuggestion from "./UnderlineBoxWithSuggestion";

const ActionBox = styled(Box)(() => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
}));

export default function SpellingItem(props) {
  const { spellingItem, translate, index, handleOpenReportDialog, onSeekToTime, selectedItemId, onItemSelection } = props;
  const { original_text, suggestion, start_time } = spellingItem;
  const [savedSuggestions, setSavedSuggestions] = useState([]); 
  const [isChecked, setIsChecked] = useState(true);
  
  // Create unique ID for this item
  const itemId = `spelling-${start_time}-${original_text.substring(0, 10)}`;
  const isSelected = selectedItemId === itemId; 

  const handleReport = () => {
    handleOpenReportDialog(spellingItem);
  };

  const handleCheckClick = () => {
    if (isChecked && suggestion) {     
      setSavedSuggestions((prevSuggestions) => [...prevSuggestions, suggestion]);     
      setIsChecked(false); // Hide the check mark after clicking
    }
  };

  const handleItemClick = () => {
    if (onSeekToTime) {
      onSeekToTime(start_time);
      onItemSelection(itemId);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      onClick={handleItemClick}
      style={{ 
        cursor: onSeekToTime ? 'pointer' : 'default',
        padding: '4px',
        borderRadius: '4px',
        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
        border: isSelected ? '2px solid #2196f3' : '2px solid transparent',
        transition: 'all 0.3s ease',
        '&:hover': onSeekToTime ? { backgroundColor: '#f5f5f5' } : {}
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gridColumnGap={3}
      >
        <TimestampBox startTime={start_time} />
        <UnderlineBoxWithSuggestion
          testid={`pre-qc-spelling-suggestion-underline-suggestion-${index}`}
          originalText={original_text}
          suggestion={suggestion}
          translate={translate}
        />
      </Box>
      <ActionBox
        data-testid={`pre-qc-spelling-suggestion-report-btn-${index}`}
        onClick={handleReport}
      >
        {isChecked && (
          <Box mr={1} onClick={handleCheckClick} style={{ cursor: "pointer" }}>
            <CheckIcon />
          </Box>
        )}
        <Box style={{ cursor: "pointer" }}> <FlagIcon/></Box>
      </ActionBox>
    </Box>
  );
}

SpellingItem.propTypes = {
  spellingItem: PropTypes.shape({
    original_text: PropTypes.string.isRequired,
    start_time: PropTypes.number.isRequired,
    suggestion: PropTypes.string,
    issue_type: PropTypes.string.isRequired,
  }).isRequired,
  translate: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  handleOpenReportDialog: PropTypes.func.isRequired,
  onSeekToTime: PropTypes.func,
  selectedItemId: PropTypes.string,
  onItemSelection: PropTypes.func,
};
